import { useStaticQuery, graphql } from 'gatsby'
export const useSiteMetadata = () => {
    const data = useStaticQuery(graphql`
        query {
            site {
                siteMetadata {
                    title
                    twitterUsername
                }
            }
        }
    `)

    return data.site.siteMetadata
}
